export function Planner1() {
  return (
    <div>
      <iframe
        title="Planner1 Concept Slides"
        src="https://docs.google.com/presentation/d/e/2PACX-1vR-10SJABhzOaPh9X3b7CcWeArYl1jcDI862bm2yG5y8gOB70EvvbRLirPA3Dm6aP4yCFlzb9K8dP9L/embed?start=false&loop=false"
        width="950"
        height="569"
        allowFullScreen={true}
      ></iframe>
    </div>
  );
}
